import itemSourceChannelData from './itemSourceChannelData.json';

/**
 * Item Source channel rule, shared by every catalog surface that renders the
 * `Item Source` toggle (`/s`, `/store/:id`, `/store/:id/detail`, their iframe
 * variants) and by the Staff Picks API.
 *
 * The split is derived at runtime from `publicData.source` instead of a
 * persisted field. `warehouseSources` lists the integration origins that ship
 * from a central warehouse rather than from a dealer's own shelf; everything
 * else, including listings with no `source`, is `in-store`.
 *
 * The values live in `itemSourceChannelData.json` because `server/api/staff-picks.js`
 * is CommonJS and cannot import this ES module. That JSON file is the single
 * source of truth for both sides; keep new warehouse-backed integrations there.
 */
export const IN_STORE = 'in-store';
export const WAREHOUSE = 'warehouse';

export const WAREHOUSE_SOURCES = Object.freeze([...itemSourceChannelData.warehouseSources]);

// Comma-separated OR value for a Sharetribe `pub_source` query parameter.
// NOTE: `pub_source` has no search schema, so Sharetribe silently ignores it
// (see docs/epro-duplicate-listing-cleanup-event.md). The parameter is kept
// correct for the day the field is indexed; the effective filtering is the
// client-side predicate below.
export const WAREHOUSE_SOURCE_QUERY_VALUE = WAREHOUSE_SOURCES.join(',');

export const isWarehouseChannel = channelRaw => channelRaw === WAREHOUSE;

export const isWarehouseSource = source => WAREHOUSE_SOURCES.includes(source);

export const isWarehouseListing = listing =>
  isWarehouseSource(listing?.attributes?.publicData?.source);
